export enum Cuisines {
  Mediterranean = "Mediterranea",
  International = "Internacional",
}
